export const appendQueryParams = (urlString, params) => {
  const url = new URL(urlString);
  Object.entries(params).forEach(([k, v]) => url.searchParams.append(k, v));
  return url;
};

export default {
  appendQueryParams,
};
